import React, { useCallback, useEffect, useRef, useState } from "react";

import { HeroSectionContainer } from "components/hero-section";

import { xPlacementOffset } from "../../../../integrations-scroller/item";
import styles from "./index.module.css";
import Item, { integrationList } from "./item";

const getBreakpoints = (maxFit: number) => {
  let breakpoints: number[] = [];
  let runningTotal = 0;
  const pattern = [maxFit, maxFit - 1];

  while (runningTotal < integrationList.length) {
    for (let i = 0; i < pattern.length; i++) {
      const num = pattern[i];

      runningTotal += num;

      if (runningTotal >= integrationList.length) {
        continue;
      }

      breakpoints.push(runningTotal);
    }
  }

  return breakpoints;
};

const Logos = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [breakIndices, setBreakIndices] = useState<number[]>([]);
  const [logoSize, setLogoSize] = useState<number>(parseInt(styles.logoSize));
  const lastBreakpointIndex = useRef(0);
  const xOffset = (logoSize * xPlacementOffset) / 2;
  const widthRef = useRef(0);

  const getLogoSize = useCallback(() => {
    let logoSize = styles.logoSize;

    if (window.innerWidth > 500) {
      logoSize = styles.xsLogoSize;
    }

    if (window.innerWidth > 768) {
      logoSize = styles.mdLogoSize;
    }

    return parseInt(logoSize);
  }, []);

  const updateBreakpoints = useCallback(() => {
    if (!containerRef.current || widthRef.current === window.innerWidth) {
      return;
    }

    widthRef.current = window.innerWidth;
    const newSize = getLogoSize();
    const inverseOffset = (100 - 100 * xPlacementOffset) / 100;
    const maxFit = Math.floor(containerRef.current.clientWidth / (newSize * inverseOffset));
    setLogoSize(newSize);
    setBreakIndices(getBreakpoints(maxFit));
  }, [getLogoSize]);

  useEffect(() => {
    updateBreakpoints();

    window.addEventListener("resize", updateBreakpoints);

    return () => {
      window.removeEventListener("resize", updateBreakpoints);
    };
  }, [updateBreakpoints]);

  return (
    <HeroSectionContainer className="items-center pb-10 sm:pb-14">
      <div className="px-4">
        <div className={styles.logos} ref={containerRef}>
          {integrationList.map((integration, index) => {
            const breakIndex = breakIndices.indexOf(index);

            if (index === 0) {
              lastBreakpointIndex.current = 0;
            } else if (breakIndex > -1) {
              lastBreakpointIndex.current = breakIndex;
            }

            return (
              <Item
                key={integration}
                breakIndices={breakIndices}
                index={index}
                integration={integration}
                yOffset={-(logoSize * 0.35)}
                xOffset={xOffset}
              />
            );
          })}
        </div>
      </div>
    </HeroSectionContainer>
  );
};

export default Logos;
